import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toValidId',
})
export class ToValidIdPipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value && value !== 0) return '';

    // First strip HTML tags
    const tempElement = document.createElement('div');
    tempElement.innerHTML = value.toString();
    const textContent = tempElement.textContent || tempElement.innerText || '';

    // Convert to valid ID:
    // 1. Trim whitespace
    // 2. Replace spaces and special characters with hyphens
    // 3. Remove any remaining invalid characters
    // 4. Ensure it starts with a letter (prefix with 'id-' if it doesn't)
    // 5. Convert to lowercase for consistency
    let id = textContent
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^a-z0-9-_]/g, '') // Remove invalid characters
      .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
      .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens

    // Ensure ID starts with a letter (prefix with 'id-' if it doesn't)
    if (id && !/^[a-z]/.test(id)) {
      id = 'id-' + id;
    }

    return id || 'id-unnamed';
  }
}
